const focusableElSelectors = [
  '[role="button"]',
  '[tabindex="0"]',
  "a",
  "button",
  "textarea",
  "input",
  "select",
  "[contenteditable]",
].join(", ");

const id = "supportWidgetContainerId";

export default (addFocus) => {
  const element = document.getElementById(id);

  function init() {
    const endElement = document.getElementById(`${id}-end`);
    if (endElement) {
      element.removeChild(endElement);
    }
    const focusableEls = element.querySelectorAll(focusableElSelectors);
    const firstElement = focusableEls[0];
    const lastElement = focusableEls[focusableEls.length - 1];

    const firstListener = () => lastElement && lastElement.focus();
    const lastListener = () => firstElement && firstElement.focus();

    const isInitialized = element.getAttribute("tabindex");
    if (!isInitialized) {
      element.setAttribute("tabindex", 0);
      element.addEventListener("focus", firstListener);
    } else {
      element.removeEventListener("focus", firstListener);
      element.addEventListener("focus", firstListener);
    }

    const div = document.createElement("div");
    div.setAttribute("id", `${id}-end`);
    div.setAttribute("tabindex", 0);
    div.addEventListener("focus", lastListener);
    element.appendChild(div);

    if (addFocus || !isInitialized) {
      setTimeout(() => {
        element.focus();
      }, 0);
    }

    return () => {
      element.removeEventListener("focus", firstListener);
      div.removeEventListener("focus", lastListener);
    };
  }

  if (element) {
    return init();
  }
};



// WEBPACK FOOTER //
// ./utils/trapFocus.js